// removed by extract-text-webpack-plugin
module.exports = {"content":"Layout__content__3moQl"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Layouts/Layout.css
// module id = 41
// module chunks = 0